import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
  Button,
} from '@mui/material';
import {
  MedicalServices as NursingIcon,
  OpenInNew as OpenInNewIcon,
} from '@mui/icons-material';

interface EscalationsProps {
  userRole?: string;
}

const Escalations: React.FC<EscalationsProps> = ({ userRole }) => {
  // Check if user has admin access (superuser or manager)
  const isAdmin = userRole === 'superuser' || userRole === 'manager';

  const formUrl = 'https://forms.zohopublic.com/directmeds1/form/NursingCSTelesalesRequests/formperma/IaS4zhJvXgNRBFBK5R6uDM-l7fwet4D7aCq5OgVdEhY';
  const adminUrl = 'https://projects.zoho.com/portal/directmeds#zp/projects/2372139000001037101/tasks/custom-view/2372139000000046003/list?group_by=tasklist';

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header */}
      <Paper sx={{ p: 3, mb: 3, bgcolor: '#f8f9fa', borderLeft: '4px solid #2196F3' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <NursingIcon sx={{ fontSize: 40, color: '#2196F3' }} />
          <Box>
            <Typography variant="h4" gutterBottom fontWeight="bold" sx={{ color: '#2C3E50', mb: 0.5 }}>
              🚨 Escalations
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Submit escalation requests for customer service or nursing concerns
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Form Card */}
      <Card elevation={3}>
        <CardContent sx={{ p: 0 }}>
          <Box>
            <Box sx={{ p: 3, bgcolor: '#f5f5f5', borderBottom: '2px solid #e0e0e0' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Box>
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    🏥 Customer Service & Nursing Escalation Form
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Use this form to escalate customer service issues, medical questions, or nursing concerns that require immediate attention.
                  </Typography>
                </Box>
                {isAdmin && (
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<OpenInNewIcon />}
                    href={adminUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Admin Portal
                  </Button>
                )}
              </Box>
            </Box>
            <Box sx={{ height: '800px', bgcolor: 'white' }}>
              <iframe
                src={formUrl}
                frameBorder="0"
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                }}
                title="Customer Service & Nursing Escalation Form"
              />
            </Box>
          </Box>
        </CardContent>
      </Card>

      {/* Instructions */}
      <Paper sx={{ p: 3, mt: 3, bgcolor: '#e3f2fd' }}>
        <Typography variant="h6" gutterBottom fontWeight="bold" color="primary">
          📋 Escalation Guidelines
        </Typography>
        <Typography variant="body2" component="div">
          <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
            <li>Fill out all required fields completely and accurately</li>
            <li>Provide as much detail as possible about the issue</li>
            <li>Include customer name, order number, and contact information</li>
            <li>Escalations are reviewed and prioritized by management</li>
            <li>You will receive updates on the status of your escalation</li>
          </ul>
        </Typography>
      </Paper>
    </Container>
  );
};

export default Escalations;
